/*
 * File: PatientSearchDialog.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Dialog for searching for a patient
 */
import React from "react";
import { observer } from "mobx-react";
import UIProgress from "components/ui/UIProgress";
import PatientSearch from "services/patients/search/components/PatientSearch";
import SearchResults from "services/patients/search/components/SearchResults";
import PatientSearchStore from "services/patients/search/store/Store";
import CloseIcon from "@material-ui/icons/Close";
import { Dialog, DialogContent } from "@material-ui/core";
import UIDialogToolbar from "components/ui/UIDialogToolbar";
import PropTypes from "prop-types";
import { StoreContext } from "utils/useStore";

class PatientSearchDialog extends React.Component {
  static contextType = StoreContext;

  get store() {
    return this.context.getStore(PatientSearchStore);
  }

  componentDidMount() {
    this.store.clearSearch();
  }

  onResultClick = patient => {
    this.props.parentCallBack(patient, patient.patientProviderId);
    this.props.toggleSearchDialog();
  };

  render() {
    let { loading, patients, searched } = this.store;
    let { showSearchDialog, toggleSearchDialog } = this.props;
    return (
      <Dialog open={showSearchDialog} fullScreen>
        <UIDialogToolbar
          title={"Patient Search"}
          rightNav={() => (
            <CloseIcon onClick={toggleSearchDialog} color="inherit" />
          )}
        />
        <PatientSearch store={this.store} />
        <DialogContent>
          {loading && <UIProgress />}
          {!loading && patients && (
            <SearchResults
              parentCallBack={this.onResultClick}
              patients={patients}
              hasSearched={searched}
            />
          )}
        </DialogContent>
      </Dialog>
    );
  }
}

PatientSearchDialog.propTypes = {
  showSearchDialog: PropTypes.bool,
  toggleSearchDialog: PropTypes.func.isRequired,
  parentCallBack: PropTypes.func.isRequired
};

export default observer(PatientSearchDialog);
